import { combineReducers } from 'redux'

import { makeCommunicationReducer } from 'shared/utils/communication/reducer/makeCommunicationReducer'
import { IAltenarState } from '../types'

import * as actions from '../actions'

export default combineReducers<IAltenarState['communications']>({
  getSportToken: makeCommunicationReducer(actions.getSportToken),
})
